/** Tasks sahifasi lug'ati (en: manba). */
export default {
  title: "Tasks",
  myReminders: "My reminders",
  subtitle: "My reminders · {{overdue}} overdue · {{today}} today · {{upcoming}} upcoming",
  subtitleFor: "{{name}} · {{overdue}} overdue · {{today}} today · {{upcoming}} upcoming",
  addReminder: "Add reminder",
  sort: "Sort: Due date",
  chips: { all: "All", expiry: "CDL / medical expiry" },
  loadFailed: "Could not load reminders.",
  empty: {
    title: "No reminders",
    desc: "Add a reminder from a driver profile or with the button above. CDL and medical card expiry reminders are created automatically.",
  },
  upcoming: "Upcoming",
  toast: {
    snoozed: "Snoozed until {{when}}",
    reopened: "Reopened",
    updateFailed: "Could not update the reminder",
    added: "Reminder added",
    addFailed: "Could not add the reminder",
  },
  completedToday: "Completed today",
  late: {
    days_one: "{{count}} day late",
    days_other: "{{count}} days late",
    hours_one: "{{count}} hour late",
    hours_other: "{{count}} hours late",
    justNow: "just now",
  },
  zone: { tashkent: "Tashkent" },
  assigneeLabel: "Assigned to", assigneeAll: "Everyone's tasks",
  assigneeChip: "Tasks of {{name}}", assigneeChipUnknown: "Selected person's tasks",
  snooze: {
    button: "Snooze",
    hour: "1 hour",
    tomorrow: "Tomorrow 9:00",
    nextMonday: "Next Monday 9:00",
    custom: "Custom ({{zone}})",
    set: "Set",
  },
  add: {
    title: "Add reminder",
    desc: "A reminder shows in your Tasks and on the driver's profile.",
    driver: "Driver",
    change: "Change",
    searchPlaceholder: "Search by name or phone",
    searching: "Searching…",
    noDrivers: "No drivers found",
    type: "Type",
    due: "Due ({{zone}})",
    note: "Note",
    notePlaceholder: "Call back about the Northline job",
    driverTime: "Driver time:",
    chooseDriver: "Choose a driver.",
    chooseDateTime: "Choose date and time.",
  },
};
